import { get, post } from '../utils/makeRequest';

const EMAIL_ENDPOINTS = {
  SEND_BULK_EMAIL: '/admin/send-bulk-email',
  GET_EMAIL_LOGS: '/admin/email-logs',
  GET_EMAIL_LOG_DETAILS: '/admin/email-logs',
};

export const emailService = {
  sendBulkEmail: async (emailData) => {
    return post(EMAIL_ENDPOINTS.SEND_BULK_EMAIL, emailData);
  },

  getEmailLogs: async (page = 1, limit = 20) => {
    return get(`${EMAIL_ENDPOINTS.GET_EMAIL_LOGS}?page=${page}&limit=${limit}`);
  },

  getEmailLogDetails: async (logId) => {
    return get(`${EMAIL_ENDPOINTS.GET_EMAIL_LOG_DETAILS}/${logId}`);
  }
};
